// extracted by mini-css-extract-plugin
export default {"products":"Products_products__s4T9C","head":"Products_head__-mQs9","title":"Products_title__5hh2t","wrapper":"Products_wrapper__gn7Ue"};